import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Prismic from 'prismic-javascript';
import MetaTags from 'react-meta-tags';

import Header from '../../components/header';
import Newsletter from '../../components/newsletter';
import Footer from '../../components/footer';
import ProductHeader from './product-header';
import BoxInformacoesTecnicas from './box-informacoes-tecnicas';
import BoxDownloads from './box-downloads';
import Banner from './banner';
import Combinations from './combinations';
import Content from './content';
import Buttons from './buttons';
import BoxConteudo from './box-conteudo';
import Gallery from './gallery';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  background: #DEDEDE;
  .columns {
    @media (min-width: 980px) {
      display: flex;
      justify-content: space-between;
      .column {
        width: 60%;
        &:first-child {
          width: 35%;
        }
      }
    }
    @media (min-width: 540px) and (max-width: 980px) {
      display: flex;
      justify-content: space-between;
      .column {
        width: 48%;
      }
    }
    @media (max-width: 540px) {
      top: -50px;
      position: relative;
    }
  }
  @media (max-width: 789px) {
    margin-top: 60px;
  }
`

const Disclaimer = styled.div`
  font-size: 14px;
  padding: 20px 0 60px;
  color: #979797;
`

class Product extends Component {
  state = {
    uid: '',
    done: false,
    categoria: [],
    tipo: [],
    content: {},
    isMobile: false,
    language: '',
  }

  componentDidMount = () => {
    this.getProduct();
    window.addEventListener("resize", this.resize.bind(this));
    this.resize()
  }

  resize = () => {
    if (document.body.clientWidth > 540) {
      this.setState({ isMobile: false });
    } else {
      this.setState({ isMobile: true });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize);
  }

  componentDidUpdate = () => {
    const { language } = this.context;
    if (
      this.props.match.params.uid !== this.state.uid ||
      language !== this.state.language
    ) {
      this.setState({language: language})
      window.scrollTo(0, 0)
      this.getProduct();  
    }
  }
  
  getProduct() {
    const { language } = this.context;

    const apiEndpoint = 'https://guararapes.cdn.prismic.io/api/v2'
    const Client = Prismic.client(apiEndpoint);

    this.setState({uid: this.props.match.params.uid});

    const fetchDataTipo = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('document.type', 'tipo_de_produtos'),
        {lang: language}
      )
      if (response) {
        this.setState({tipo: response.results});
        if (this.state.categoria.length > 0)
          fetchData();
      }
    }
    fetchDataTipo();

    const fetchDataCategoria = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('document.type', 'categoria_produtos'),
        {lang: language}
      )
      if (response) {
        this.setState({categoria: response.results});
        if (this.state.tipo.length > 0)
          fetchData();
      }
    }
    fetchDataCategoria();

    const fetchData = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('my.produto.uid', this.props.match.params.uid),
        {lang: language}
      )
      if (response.results[0]) {
        const product = response.results[0].data
        product.categoria = this.state.categoria.filter((item) => item.id === product.categoria_produto.id)[0]
        product.tipo = this.state.tipo.filter((item) => item.id === product.tipo_de_produto.id)[0]
        this.setState({content: product, done: true});
      }
    }
  }

  render = () => {
    const { language } = this.context;
    let disclaimer = ''
    switch (language) {
      case 'pt-br':
        disclaimer = '* As imagens virtuais ou impressas são de caráter ilustrativo e podem sofrem alterações de cores em cada monitor ou impressora.<br/>  ' +
          'Recomendamos que a escolha do painel seja realizada com base na amostra física do produto.';
        break;
      case 'en-us':
        disclaimer = '* The virtual or printed images are for illustrative purposes and may undergo color changes in each monitor or printer.<br/>  ' +
          'We recommend that the panel be chosen based on the physical sample of the product.';
        break;
      case 'es-es':
        disclaimer = '* Las imágenes virtuales o impresas tienen fines ilustrativos y pueden sufrir cambios de color en cada monitor o impresora.<br/>  ' +
          'Recomendamos que el panel se elija en función de la muestra física del producto.';
        break;
      default:
    }
    return (
      <div id="home">
        <MetaTags>
          <title>{ this.state.content.meta_title }</title>
          <meta id="meta-description" name="description" content={ this.state.content.meta_description } />
          <meta id="og-title" property="og:title" content={ this.state.content.meta_title } />
        </MetaTags>
        <Header />
        {
          this.state.done && (
            <ProductHeader {...this.state.content} />
          )
        }
        {
          this.state.done && (
            <Container>
              <div className="wrapper">
                <div className="columns">
                  <div className="column">
                    { this.state.isMobile && <Gallery {...this.state.content} /> }
                    <Content {...this.state.content} />
                    <BoxInformacoesTecnicas {...this.state.content} />
                    {
                      (this.state.content.downloads && this.state.content.downloads.length > 0) && (
                        <BoxDownloads {...this.state.content} />
                      )
                    }
                    <Buttons {...this.state.content} />
                  </div>
                  <div className="column">
                    { !this.state.isMobile && <Gallery {...this.state.content} /> }
                    <BoxConteudo {...this.state.content} />
                  </div>
                </div>
                <Combinations categoria={this.state.categoria} {...this.state.content} />
                <Banner {...this.state.content} />
                <Disclaimer dangerouslySetInnerHTML={{__html: disclaimer }} />
              </div>
            </Container>
          )
        }
        <Newsletter />
        <Footer />
      </div>
    );
  }
}

Product.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

Product.contextType = LanguageContext;

export default Product;
